import React from 'react';

import { StaffListItem } from '@vyce/core/src/types';

import { OnboardingStepTitle } from '../../../components';
import { ControlledTagAutocomplete } from '../../../components/controlled-inputs';

type Props = {
  staff: {
    uuid: string;
    name: string;
    existing: StaffListItem;
  }[];
  setSubstring: (substring: string) => void;
};

export const PayScheduleManagersStep = ({ staff, setSubstring }: Props) => {
  return (
    <>
      <OnboardingStepTitle text="Would you like to assign any Managers to this Pay Schedule?" />

      <ControlledTagAutocomplete
        name="payScheduleManagers"
        margin="none"
        items={staff}
        label="Pay Schedule Managers (optional)"
        setSubstring={setSubstring}
        multiple
      />
    </>
  );
};
